<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '31.25rem', maxWidth: '90vw' }"
  [draggable]="false"
  [resizable]="false">
  <ng-template #header>
    <div class="dialog-header">
      <span>{{ 'SETTINGS.PUSH_NOTIFICATIONS.TEST_DIALOG.TITLE' | translate }}</span>
    </div>
  </ng-template>

  <div class="test-push-form">
    <p class="description">
      {{ 'SETTINGS.PUSH_NOTIFICATIONS.TEST_DIALOG.DESCRIPTION' | translate }}
    </p>

    @if (device(); as currentDevice) {
      <div class="device-summary">
        <div class="device-row">
          <span class="device-label">{{ 'SETTINGS.PUSH_NOTIFICATIONS.USER' | translate }}</span>
          <span class="device-value">{{ currentDevice.lastname }}, {{ currentDevice.firstname }}</span>
        </div>
        <div class="device-row">
          <span class="device-label">{{ 'SETTINGS.PUSH_NOTIFICATIONS.TEST_DIALOG.DEVICE' | translate }}</span>
          <span class="device-value">
            <i [class]="getPlatformIcon(currentDevice.platformType)" aria-hidden="true"></i>
            <span class="device-platform">{{ getPlatformLabelKey(currentDevice.platformType) | translate }}</span>
            <span class="device-name">
              {{ currentDevice.deviceInfo ?? ('SETTINGS.PUSH_NOTIFICATIONS.UNKNOWN_DEVICE' | translate) }}
            </span>
          </span>
        </div>
        @if (currentDevice.tokenPrefix) {
          <div class="device-row">
            <span class="device-label">{{ 'SETTINGS.PUSH_NOTIFICATIONS.TEST_DIALOG.TOKEN' | translate }}</span>
            <span class="device-value device-token">{{ currentDevice.tokenPrefix }}…</span>
          </div>
        }
      </div>
    }
  </div>

  @if (logEntries().length > 0) {
    <output class="test-log" aria-live="polite">
      @for (entry of logEntries(); track $index) {
        <div
          class="test-log-entry"
          [class.test-log-entry--success]="entry.severity === 'success'"
          [class.test-log-entry--error]="entry.severity === 'error'">
          {{ entry.message }}
        </div>
      }
    </output>
  }

  <ng-template #footer>
    <p-button
      [label]="'GENERAL.CLOSE' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="onClose()" />
    <p-button
      [label]="'SETTINGS.PUSH_NOTIFICATIONS.TEST_DIALOG.SEND_BUTTON' | translate"
      icon="pi pi-send"
      severity="primary"
      [disabled]="testInProgress() || !device()"
      [attr.aria-label]="'SETTINGS.PUSH_NOTIFICATIONS.TEST_DIALOG.SEND_BUTTON' | translate"
      (onClick)="onSend()" />
  </ng-template>
</p-dialog>
